var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailBold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.375,
    height: 37.5,
    viewBox: "0 0 39.375 37.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mail-bold",
    transform: "translate(-3.75 -5.625)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10541",
    "data-name": "Path 10541",
    d: "M33.75,24.375a9.375,9.375,0,1,1-9.375,9.375A9.366,9.366,0,0,1,33.75,24.375Zm3.825,5.55H33.75a1.275,1.275,0,1,0,0,2.55h3.825a1.275,1.275,0,0,0,0-2.55Zm-7.65,7.65h7.65a1.275,1.275,0,0,0,0-2.55H29.906A1.276,1.276,0,0,0,28.631,36.3,1.293,1.293,0,0,0,29.925,37.575Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10542",
    "data-name": "Path 10542",
    d: "M13.125,5.625h18.75C37.5,5.625,41.25,8.438,41.25,15v5.888a1.877,1.877,0,0,1-2.662,1.688,12.174,12.174,0,0,0-16.781,8.719,12.391,12.391,0,0,0-.131,4.144,1.863,1.863,0,0,1-1.856,2.081H13.125c-5.625,0-9.375-2.812-9.375-9.375V15C3.75,8.438,7.5,5.625,13.125,5.625Zm-.881,10.481,5.869,4.688a7.238,7.238,0,0,0,8.775,0l5.869-4.687a1.442,1.442,0,0,0,.225-1.987,1.4,1.4,0,0,0-1.969-.225l-5.869,4.688a4.474,4.474,0,0,1-5.269,0l-5.869-4.687a1.384,1.384,0,0,0-1.969.225A1.422,1.422,0,0,0,12.244,16.106Z",
    fill: "#fd792f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailBold);
export default __webpack_public_path__ + "static/media/mail-bold.408341ebb27a7cf8f662196c25f8f461.svg";
export { ForwardRef as ReactComponent };